export default __webpack_public_path__ + "static/media/icone-youtube.5c4e5306.svg";